module.exports = __webpack_public_path__ + "static/media/TC Logo.75d9db67.jpg";